import { render } from "./RefreshPageSpinner.vue?vue&type=template&id=07713882&scoped=true"
import script from "./RefreshPageSpinner.vue?vue&type=script&lang=js"
export * from "./RefreshPageSpinner.vue?vue&type=script&lang=js"

import "./RefreshPageSpinner.vue?vue&type=style&index=0&id=07713882&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07713882"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QBtn});
